import React, { useEffect, useRef, useState } from 'react'
import Accordion from '../../atoms/Accordion/Accordion'
import Tabs from '../Tabs/Tabs'
import { Larghezza, Download, Goccia, Altezza, Zoom } from '../../atoms/NewIcons'
import Button from '../../atoms/Button/Button'
import { Trans } from '../../atoms'
import { ChevronDown, Imballi } from './../../atoms/NewIcons'
import useTrans from '../../../hooks/useTrans'
import DettagliProdottoListino from '../DettagliProdottoListino/DettagliProdottoListino'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import useDownloadFromApi from '../../../hooks/useDownloadFromApi'
import LoadingSvg from '../../atoms/Loading/Loading'
import Color from '../../atoms/Color/Color'
import { useMemo } from 'react'
import { ChipAttributiDropdown } from '../../atoms/Chip/Chip'
import { showDettagliPersonalizzaione } from '../../../utils/servicegift'
import { getAltText, handleScrollRef } from '../../../utils/safe'
import DettagliProdottoListinoConfezionamento from '../DettagliProdottoListinoConfezionamento/DettagliProdottoListinoConfezionamento'
import Link from 'next/link'
import FormSelect from '../../atoms/FormSelect/FormSelect'
import FormField from '../../atoms/FormField/FormField'
import MyImage from '../../atoms/MyImage/MyImage'
import NewModal from '../../molecules/NewModal/NewModal'
import { GocciaColor, GocciaSlash } from '@components/icons'

const DettagliProdottoRecapItem = ({ label, value }) => {
  return (
    <div className="dettagli-prodotto__recap__item">
      <p className="dettagli-prodotto__recap__label">{label}:</p>
      <div className="dettagli-prodotto__recap__value">{value}</div>
      <span className="dettagli-prodotto__recap__arrow">
        <ChevronDown />
      </span>
    </div>
  )
}

export const DettagliProdottoData = ({ label, value, html = false, className }) => {
  return (
    <div className={`dettagli-prodotto__data ${className ? className : ''}`}>
      <p className="dettagli-prodotto__data__label">{label}</p>
      {html ? (
        <div
          className="dettagli-prodotto__data__value"
          dangerouslySetInnerHTML={{
            __html: value,
          }}
        />
      ) : (
        <p className="dettagli-prodotto__data__value">{value}</p>
      )}
    </div>
  )
}

const DettagliProdottoDocumentazioneButton = ({
  label,
  url,
  filename,
  downloading,
  saveFile,
  fromApi,
}) => {
  return fromApi ? (
    <div className="dettagli-prodotto__documentazione__button-wrap">
      <a
        href={url}
        onClick={(e) => {
          e.preventDefault()
          if (downloading) return
          saveFile(filename, url, filename)
        }}
        disabled={downloading ? true : false}
      >
        <Button
          label={label}
          icon={downloading == filename ? <LoadingSvg /> : <Download />}
          icon_pos="left"
          variant="ghost"
          color="black"
          size="medium"
          disabled={downloading ? true : false}
        />
      </a>
    </div>
  ) : (
    <div className="dettagli-prodotto__documentazione__button-wrap">
      <a href={url} download target="_blank">
        <Button
          label={label}
          icon={<Download />}
          icon_pos="left"
          variant="ghost"
          color="black"
          size="medium"
        />
      </a>
    </div>
  )
}

const DettagliProdotto = ({
  selectedArticolo: initialSelectedArticolo,
  selectedColore: initialSelectedColore,
  selectedTaglia: initialSelectedTaglia,
  prodotto,
  showSelectorColore,
  showSelectorTaglia,
  personalizzazioni,
  prezziPersonalizzazioni,
  refInfoImballi,
  selectedTab,
  setSelectedTab,
  openAccordions,
  setOpenAccordions,
  handleToggleAccordion,
}) => {
  const listiniAccordionRef = useRef()
  const listiniConfezionamentoAccordionRef = useRef()
  const t = useTrans()
  const refTableSchedaProdotto = useRef(null)
  const router = useRouter()
  const { service_gift } = useSelector((state) => state.servicegift)
  const { downloading, saveFile } = useDownloadFromApi()

  const [selectedColore, setSelectedColore] = useState(initialSelectedColore) // colore selezionato nel filtro
  const [selectedTaglia, setSelectedTaglia] = useState(initialSelectedTaglia) // taglia selezionata nel filtro
  const [selectedArticolo, setSelectedArticolo] = useState(initialSelectedArticolo) // articolo selezionato sulla base dei filtri colore e taglia

  const findArticoloByAttributes = (coloreId, tagliaId) =>
    prodotto.articoli.find(
      (item) =>
        item.attributi_lista.some((attr) => attr.id === coloreId) &&
        (tagliaId ? item.attributi_lista.some((attr) => attr.id === tagliaId) : true)
    )

  const handleChangeArticolo = (newAttributo) => {
    const isColore = selectedColore.attributo_chiave === newAttributo.attributo_chiave
    const isTaglia = selectedTaglia?.attributo_chiave === newAttributo.attributo_chiave

    let updateColore = selectedColore
    let updateTaglia = selectedTaglia
    let newArticolo = null

    if (isColore) {
      // Try to keep the current taglia, if not found, fallback
      updateColore = newAttributo
      newArticolo = findArticoloByAttributes(updateColore.id, updateTaglia?.id)
      if (!newArticolo) {
        // Fallback: pick first available taglia for the selected colore
        const coloreObj = prodotto.colori?.find((colore) => colore.id === newAttributo.id)
        updateTaglia = coloreObj?.taglie?.[0] || null
        newArticolo = findArticoloByAttributes(updateColore.id, updateTaglia?.id)
      }
    } else if (isTaglia) {
      // Try to keep the current colore, if not found, fallback
      updateTaglia = newAttributo
      newArticolo = findArticoloByAttributes(updateColore?.id, updateTaglia.id)
      if (!newArticolo) {
        // Fallback: pick first available colore for selected taglia
        const firstColore = prodotto.colori?.[0] || null
        updateColore = firstColore
        newArticolo = findArticoloByAttributes(updateColore?.id, updateTaglia.id)
      }
    }

    setSelectedColore(updateColore)
    setSelectedTaglia(updateTaglia)
    setSelectedArticolo(newArticolo)
  }

  const articoliWithEan = prodotto?.articoli?.filter((x) => x?.ean !== null) || []
  const articoloPesoLordo = selectedArticolo?.peso_lordo

  const handleVisualizzaPrezziListini = () => {
    setSelectedTab('personalizzazione')
    setOpenAccordions((prevIds) => [
      ...prevIds.filter((id) => id !== 'listino-prodotto'),
      'listino-prodotto',
    ])
    setTimeout(() => {
      handleScrollRef(listiniAccordionRef)
    }, 200)
  }

  const handleVisualizzaPrezziConfezionamento = () => {
    setSelectedTab('personalizzazione')
    setOpenAccordions((prevIds) => [
      ...prevIds.filter((id) => id !== 'listino-confezionamento-prodotto'),
      'listino-confezionamento-prodotto',
    ])
    setTimeout(() => {
      handleScrollRef(listiniConfezionamentoAccordionRef)
    }, 200)
  }

  // --- Blocchi Accordion per Tabs ---
  const AccordionSpecifiche = (
    <Accordion
      placeholder={t('Specifiche')}
      size="extralarge"
      open={openAccordions.includes('specifiche')}
      onToggle={() => handleToggleAccordion('specifiche')}
      id="specifiche"
    >
      <div className="dettagli-prodotto__accordion-content">
        <div className="dettagli-prodotto__data-list">
          <DettagliProdottoData label={t('Codice articolo')} value={selectedArticolo?.codice} />
          <DettagliProdottoData label={t('Colore')} value={selectedColore?.nome} />
          <DettagliProdottoData
            label={t('Colori disponibili')}
            value={prodotto.colori.map((item) => item?.nome).join(', ')}
          />
          <DettagliProdottoData
            label={t('Descrizione')}
            value={
              selectedArticolo?.descrizione_lunga
                ? selectedArticolo?.descrizione_lunga
                : selectedArticolo?.descrizione
            }
            html={selectedArticolo?.descrizione_lunga ? true : false}
          />
          {prodotto.materiale && (
            <DettagliProdottoData label={t('Materiale')} value={prodotto.materiale?.nome} />
          )}

          {prodotto.taglie.length > 0 && selectedTaglia && (
            <DettagliProdottoData
              label={t('Taglie disponibili')}
              value={prodotto.taglie
                .filter((item) => item.id != selectedTaglia.id)
                .map((item) => item?.nome)
                .join('/')}
            />
          )}

          {selectedArticolo?.attributi_lista.filter((item) => item.attributo_chiave == 'manico')
            .length > 0 && (
              <DettagliProdottoData
                label={t('Misure manico')}
                value={
                  selectedArticolo.attributi_lista.filter(
                    (item) => item.attributo_chiave == 'manico'
                  )[0]?.nome
                }
              />
            )}

          {selectedArticolo?.attributi_lista.filter((item) => item.attributo_chiave == 'capacita')
            .length > 0 && (
              <DettagliProdottoData
                label={t('Capacità')}
                value={
                  <p className="dettagli-prodotto__capacita">
                    <span className="dettagli-prodotto__capacita__tag">
                      {
                        selectedArticolo.attributi_lista.filter(
                          (item) => item.attributo_chiave == 'capacita'
                        )[0]?.nome
                      }
                    </span>
                    <span className="dettagli-prodotto__capacita__label">
                      {
                        selectedArticolo.attributi_lista.filter(
                          (item) => item.attributo_chiave == 'capacita'
                        )[0]?.nome
                      }
                    </span>
                  </p>
                }
              />
            )}
          {prodotto.brand && (
            <DettagliProdottoData
              label={t('Marchio')}
              value={
                <img
                  src={prodotto.brand.image?.url}
                  alt={getAltText(prodotto.brand.nome.image) || prodotto.brand.nome}
                  title={prodotto.brand.nome}
                  className="dettagli-prodotto__brand"
                />
              }
            />
          )}

          {prodotto.voce_doganale && (
            <DettagliProdottoData
              label={t('Codice Doganale')}
              value={prodotto.voce_doganale ? prodotto.voce_doganale : '-'}
            />
          )}
          {!!selectedArticolo.paese_origine && (
            <DettagliProdottoData
              label={t('Paese di origine')}
              value={selectedArticolo.paese_origine}
            />
          )}

          {prodotto.dimensione_legacy && (
            <DettagliProdottoData label={t('Dimensioni')} value={prodotto.dimensione_legacy} />
          )}

          {!!articoloPesoLordo && (
            <DettagliProdottoData
              label={t('Peso')}
              value={`${Number(articoloPesoLordo).toFixed(2).replace('.', ',')} Kg`}
            />
          )}

          {selectedArticolo?.grammatura && (
            <DettagliProdottoData label={t('Grammatura')} value={selectedArticolo.grammatura} />
          )}

          {prodotto?.alternativo?.codice && (
            <DettagliProdottoData
              label={t('Prodotto alternativo')}
              value={<a href={prodotto.alternativo.url}>{prodotto.alternativo.codice}</a>}
            />
          )}

          {selectedArticolo?.note && (
            <DettagliProdottoData
              label={t('Note')}
              value={selectedArticolo.note ? selectedArticolo.note : '-'}
              html
            />
          )}
        </div>
      </div>
    </Accordion>
  )

  const AccordionEAN =
    articoliWithEan && articoliWithEan.length > 0 ? (
      <Accordion
        placeholder={t('Codici EAN GS1')}
        size={'extralarge'}
        open={openAccordions.includes('ean')}
        onToggle={() => handleToggleAccordion('ean')}
        id="ean"
      >
        <div className={'dettagli-prodotto__ean'}>
          <div className={'dettagli-prodotto__ean__column'}>
            <div className={'dettagli-prodotto__ean__header'}>{t('Codice')}</div>
            {articoliWithEan.map((x) => (
              <div className={'dettagli-prodotto__ean__element'} key={x?.id}>
                {x?.codice}
              </div>
            ))}
          </div>
          {articoliWithEan.some((x) =>
            x?.attributi_lista?.find((attributo) => attributo.attributo_chiave === 'colore')
          ) && (
              <div className={'dettagli-prodotto__ean__column'}>
                <div className={'dettagli-prodotto__ean__header'}>{t('Colore')}</div>
                {articoliWithEan.map((x) => (
                  <div className={'dettagli-prodotto__ean__element'} key={x?.id}>
                    <Color
                      img={
                        x?.attributi_lista?.find(
                          (attributo) => attributo.attributo_chiave === 'colore'
                        )?.image
                      }
                    />
                  </div>
                ))}
              </div>
            )}
          {articoliWithEan.some((x) =>
            x?.attributi_lista?.find((attributo) => attributo.attributo_chiave === 'taglia')
          ) && (
              <div className={'dettagli-prodotto__ean__column'}>
                <div className={'dettagli-prodotto__ean__header'}>{t('Taglia')}</div>
                {articoliWithEan.map((x) => (
                  <div className={'dettagli-prodotto__ean__element'} key={x?.id}>
                    {
                      x?.attributi_lista?.find((attributo) => attributo.attributo_chiave === 'taglia')
                        ?.nome
                    }
                  </div>
                ))}
              </div>
            )}
          <div className={'dettagli-prodotto__ean__column'}>
            <div className={'dettagli-prodotto__ean__header'}>{t('Codice EAN')}</div>
            {articoliWithEan.map((x) => (
              <div className={'dettagli-prodotto__ean__element'} key={x?.id}>
                {x?.ean}
              </div>
            ))}
          </div>
        </div>
      </Accordion>
    ) : null

  const AccordionImballi = (
    <Accordion
      placeholder={t('Info imballi')}
      size="extralarge"
      ref={refInfoImballi}
      open={openAccordions.includes('info-imballi')}
      onToggle={() => handleToggleAccordion('info-imballi')}
      id="info-imballi"
    >
      <div className="dettagli-prodotto__accordion-content">
        <div className="dettagli-prodotto__data-list">
          {selectedArticolo?.attributi_lista.filter((item) => item.attributo == 11)[0] && (
            <DettagliProdottoData
              label={t('Tipo confezione')}
              value={
                selectedArticolo.attributi_lista.filter((item) => item.attributo == 11)[0]?.nome
              }
            />
          )}
          <DettagliProdottoData
            label={t('Imballi')}
            value={
              <div className="dettagli-prodotto__imballo">
                <span className="dettagli-prodotto__imballo__icon">
                  <Imballi />
                </span>
                <span className="dettagli-prodotto__imballo__label">
                  {selectedArticolo?.imballi}
                </span>
              </div>
            }
          />
          {selectedArticolo?.sotto_imballi ? (
            <DettagliProdottoData
              label={t('Sotto imballi')}
              value={
                <div className="dettagli-prodotto__imballo">
                  <span className="dettagli-prodotto__imballo__icon">
                    <Imballi />
                  </span>
                  <span className="dettagli-prodotto__imballo__label">
                    {selectedArticolo?.sotto_imballi}
                  </span>
                </div>
              }
            />
          ) : null}
          <DettagliProdottoData
            label={t('Dimensione')}
            value={
              <div className="dettagli-prodotto__dimensioni">
                <span className="dettagli-prodotto__dimensioni__label">
                  {selectedArticolo?.altezza_imballo} x {selectedArticolo?.larghezza_imballo} x{' '}
                  {selectedArticolo?.profondita_imballo} (cm)
                </span>
              </div>
            }
          />
          {selectedArticolo?.volume_imballo ? (
            <DettagliProdottoData
              label={t('Volume Collo')}
              value={selectedArticolo?.volume_imballo}
            />
          ) : null}
          {selectedArticolo?.peso ? (
            <DettagliProdottoData
              label={t('Peso lordo collo')}
              value={String(selectedArticolo?.peso.toFixed(2)).replace('.', ',') + ' Kg'}
            />
          ) : null}
        </div>
      </div>
    </Accordion>
  )

  const AccordionSmaltimento =
    prodotto.info_smaltimento_imballaggi?.length > 0 ? (
      <Accordion
        placeholder={t('Info per smaltimento imballaggi')}
        size="extralarge"
        open={openAccordions.includes('info-smaltimento')}
        onToggle={() => handleToggleAccordion('info-smaltimento')}
        id="info-smaltimento"
      >
        <div className="dettagli-prodotto__accordion-content">
          <div className="dettagli-prodotto__data-list">
            {prodotto.info_smaltimento_imballaggi.map((info) => (
              <DettagliProdottoData
                key={`info_smaltimento_imballaggi-${info.nome}`}
                label={info.nome}
                value={info.descrizione}
              />
            ))}
          </div>
          {router.locale == 'it' && (
            <div
              className="dettagli-prodotto__disclaimer"
              dangerouslySetInnerHTML={{
                __html: t(
                  '<strong>** per tutti gli imballaggi verificare le disposizioni del proprio comune per il corretto smaltimento **</strong>'
                ),
              }}
            />
          )}
        </div>
      </Accordion>
    ) : null

  const getAreaStampa = (personalizzazione) => {
    return personalizzazione?.aree_stampa?.find((a) => a.colore.id === selectedColore.id)?.immagine
      ?.url
  }

  const [selectedTecnica, setSelectedTecnica] = useState(
    personalizzazioni ? personalizzazioni.tecniche[0] : null
  )
  const [selectedPosizione, setSelectedPosizione] = useState(
    personalizzazioni && personalizzazioni.tecniche[0]?.posizioni?.[0]
      ? personalizzazioni.tecniche[0].posizioni[0]
      : null
  )
  const [zoomModalVisible, setZoomModalVisible] = useState(false)
  const [imgAreaStampa, setImgAreaStampa] = useState(null)

  useEffect(() => {
    if (selectedTecnica && selectedTecnica.posizioni?.[0]) {
      setSelectedPosizione(selectedTecnica.posizioni[0])
    }
  }, [selectedTecnica])

  useEffect(() => {
    if (selectedTecnica && selectedPosizione && selectedColore) {
      setImgAreaStampa(
        getAreaStampa(
          selectedTecnica?.posizioni.find((x) => x.id == selectedPosizione.id)?.numero_colori?.[0]
            ?.personalizzazioni_objects?.[0]
        )
      )
    }
  }, [selectedTecnica, selectedPosizione, selectedColore])

  const colorsByTecnica = useMemo(() => {
    return (personalizzazioni?.tecniche ?? []).reduce((acc, {id, colori}) => ({...acc, [id]: colori}), {})
  }, [personalizzazioni?.tecniche])

  const AccordionPersonalizzazione =
    personalizzazioni &&
      personalizzazioni?.tecniche?.length > 0 &&
      (!service_gift || service_gift?.personalizzazione) ? (
      <Accordion
        placeholder={t('Opzioni di personalizzazione')}
        size="extralarge"
        open={openAccordions.includes('personalizzazione')}
        onToggle={() => handleToggleAccordion('personalizzazione')}
        id="personalizzazione"
      >
        <div className="dettagli-prodotto__accordion-content__opzioni">
          <DettagliProdottoTabPersonalizzazione
            personalizzazioni={personalizzazioni}
            prezziPersonalizzazioni={prezziPersonalizzazioni}
            t={t}
            prodotto={prodotto}
            refTableSchedaProdotto={refTableSchedaProdotto}
            handleVisualizzaPrezziListini={handleVisualizzaPrezziListini}
            handleVisualizzaPrezziConfezionamento={handleVisualizzaPrezziConfezionamento}
            selectedTecnica={selectedTecnica}
            setSelectedTecnica={setSelectedTecnica}
            selectedPosizione={selectedPosizione}
            setSelectedPosizione={setSelectedPosizione}
          />
          {selectedPosizione && selectedTecnica && imgAreaStampa && (
            <div className={'dettagli-prodotto__accordion-content__imagebox'}>
              <div className="configurazione-prodotto__posizioni__imageBox configurazione-prodotto__posizioni__imageBox__full">
                <button
                  className={'configurazione-prodotto__posizioni__imageBox__zoom'}
                  onClick={() => setZoomModalVisible(true)}
                >
                  <Zoom />
                </button>
                <div className="configurazione-prodotto__posizioni__image">
                  <MyImage
                    objectFit="contain"
                    onClick={() => setZoomModalVisible(true)}
                    src={imgAreaStampa}
                    width={180}
                    height={180}
                  />
                  <NewModal
                    className="datatable-prodotto__modal"
                    visible={zoomModalVisible}
                    onClose={() => setZoomModalVisible(false)}
                  >
                    <div className="main__image__wrapper">
                      <div className="main__image">
                        <MyImage
                          className=""
                          src={imgAreaStampa}
                          alt={t('Immagine articolo con area di stampa')}
                          width={800}
                          height={800}
                          loading="eager"
                          onClick={() => setZoomModalVisible(false)}
                        />
                      </div>
                    </div>
                  </NewModal>
                </div>
              </div>
            </div>
          )}
        </div>
      </Accordion>
    ) : null

  const AccordionListino =
    personalizzazioni &&
      personalizzazioni?.tecniche?.length > 0 &&
      prezziPersonalizzazioni?.tecniche?.[0]?.posizioni?.[0]?.numero_colori?.[0]
        ?.personalizzazioni_objects?.[0]?.prezzi_personalizzazione?.length > 0 &&
      (!service_gift || service_gift?.personalizzazione) ? (
      <Accordion
        placeholder={t('Listino prezzi per personalizzazione')}
        size="extralarge"
        ref={listiniAccordionRef}
        open={openAccordions.includes('listino-prodotto')}
        onToggle={() => handleToggleAccordion('listino-prodotto')}
        id="listino-prodotto"
      >
        <div className="dettagli-prodotto__accordion-content">
          <DettagliProdottoListino prezzi={prezziPersonalizzazioni} colorsByTecnica={colorsByTecnica}/>
        </div>
      </Accordion>
    ) : null

  const AccordionListinoConfezionamento =
    personalizzazioni &&
      personalizzazioni?.tecniche?.length > 0 &&
      prezziPersonalizzazioni?.tecniche?.[0]?.posizioni?.[0]?.numero_colori?.[0]
        ?.personalizzazioni_objects?.[0]?.prezzi_confezionamento?.length > 0 &&
      (!service_gift || service_gift?.personalizzazione) ? (
      <Accordion
        placeholder={t('Listino prezzi confezionamento')}
        size="extralarge"
        ref={listiniConfezionamentoAccordionRef}
        open={openAccordions.includes('listino-confezionamento-prodotto')}
        onToggle={() => handleToggleAccordion('listino-confezionamento-prodotto')}
        id="listino-confezionamento-prodotto"
      >
        <div className="dettagli-prodotto__accordion-content">
          <DettagliProdottoListinoConfezionamento prezzi={prezziPersonalizzazioni} />
        </div>
      </Accordion>
    ) : null

  const AccordionDocumentazione =
    selectedArticolo &&
      (selectedArticolo.url_scheda_tecnica || selectedArticolo.documenti?.length) ? (
      <Accordion
        placeholder={t('Documentazione')}
        size="extralarge"
        open={openAccordions.includes('documentazione')}
        onToggle={() => handleToggleAccordion('documentazione')}
        id="documentazione"
      >
        <div className="dettagli-prodotto__accordion-content">
          <div className="dettagli-prodotto__documentazione">
            <div className="dettagli-prodotto__documentazione__buttons">
              {selectedArticolo.documenti.map((item) => (
                <DettagliProdottoDocumentazioneButton
                  label={item?.nome}
                  url={`${item.url}`}
                  filename={item.label}
                />
              ))}
              {selectedArticolo?.url_scheda_tecnica && (
                <DettagliProdottoDocumentazioneButton
                  label={t('Scarica scheda prodotto in pdf')}
                  url={`${selectedArticolo.url_scheda_tecnica}`}
                  fromApi
                  downloading={downloading}
                  saveFile={saveFile}
                  filename={`${service_gift?.nome || 'sipec'}-prodotto-${prodotto?.codice}-${
                    selectedArticolo?.slug
                  }.pdf`}
                />
              )}
            </div>
          </div>
        </div>
      </Accordion>
    ) : null

  // --- Tabs ---
  const tabs = [
    {
      label: t('Dettagli prodotto'),
      id: 'dettagli',
      component: (
        <div>
          {AccordionSpecifiche}
          {AccordionEAN}
          {AccordionImballi}
          {AccordionSmaltimento}
        </div>
      ),
    },
    ...(showDettagliPersonalizzaione(prodotto, service_gift) &&
      personalizzazioni?.tecniche?.length > 0
      ? [
        {
          label: t('Opzioni di personalizzazione'),
          id: 'personalizzazione',
          component: (
            <div>
              {AccordionPersonalizzazione}
              {AccordionListino}
              {AccordionListinoConfezionamento}
            </div>
          ),
        },
      ]
      : []),
    {
      label: t('Documentazione'),
      id: 'documentazione',
      component: <div>{AccordionDocumentazione}</div>,
    },
  ]

  return (
    <div className="dettagli-prodotto">
      <div className="dettagli-prodotto__header">
        <h3 className="dettagli-prodotto__title">
          <Trans chiave="Dettagli prodotto" />
        </h3>
        <div className="dettagli-prodotto__subtitle">
          <p>
            <Trans chiave="Trova tutti i dettagli dell'articolo" />
          </p>
          <p>
            <Trans chiave="Puoi selezionare una referenza di tuo interesse per visualizzarne le relative informazioni" />
          </p>
        </div>
      </div>

      <div className="dettagli-prodotto__recap">
        {selectedColore &&
          (showSelectorColore ? (
            <ChipAttributiDropdown
              placeholder={
                <>
                  {t('Colore')}: <strong>{selectedColore.nome}</strong>
                </>
              }
              options={prodotto?.colori}
              value={selectedColore}
              setValue={handleChangeArticolo}
            />
          ) : (
            <DettagliProdottoRecapItem label={t('Colore')} value={selectedColore?.nome} />
          ))}
        {selectedTaglia &&
          (showSelectorTaglia ? (
            <ChipAttributiDropdown
              placeholder={
                <>
                  {t('Taglia')}: <strong>{selectedTaglia.nome}</strong>
                </>
              }
              options={
                prodotto?.colori?.filter((colore) => colore.id === selectedColore.id)[0]?.taglie
              }
              value={selectedTaglia}
              setValue={handleChangeArticolo}
            />
          ) : (
            <DettagliProdottoRecapItem label={t('Taglia')} value={selectedTaglia?.nome} />
          ))}
      </div>

      <div className="dettagli-prodotto__tabs">
        <Tabs
          tabs={tabs}
          activeId={selectedTab}
          onTabSelect={(tabId) => setSelectedTab(tabId)}
        />
      </div>
      <div ref={(el) => (refTableSchedaProdotto.current = el)}></div>
    </div>
  )
}

const DettagliProdottoTab = ({
  item,
  t,
  prodotto,
  showPrezziLink = true,
  handleVisualizzaPrezziListini,
  showPrezziConfezionamentoLink = true,
  handleVisualizzaPrezziConfezionamento,
  selectedPosizione,
  setSelectedPosizione,
}) => {
  const { service_gift } = useSelector((state) => state.servicegift)

  const availableColorsLabel = useMemo(() => {
    return item.colori?.length > 0 ? `(${t("solo per colori")} ${item.colori.map(({nome}) => nome).join(", ")})` : ""
  }, [item.colori])

  const confezionamento = useMemo(() => {
    return selectedPosizione?.numero_colori?.[0]?.personalizzazioni_objects?.[0]?.confezionamento
  }, [selectedPosizione])

  return selectedPosizione ? (
    <div className="dettagli-prodotto__data-list">
      <DettagliProdottoData label={t('Tecnica di stampa')} value={`${item.nome} ${availableColorsLabel}`} />

      <DettagliProdottoData
        label={t('Posizione di stampa consigliata')}
        value={
          <FormField className={'dettagli-prodotto__select'}>
            <FormSelect
              placeholder={t('Seleziona tipologia')}
              options={item.posizioni.map((x) => ({
                value: x.id,
                label: x.nome,
              }))}
              value={selectedPosizione?.id}
              onChange={(e) => {
                const newPos = item.posizioni.find((x) => x.id === e.target.value)
                setSelectedPosizione(newPos)
              }}
            />
          </FormField>
        }
      />

      <DettagliProdottoData
        label={t('Max. misure di stampa')}
        value={
          <div className="dettagli-prodotto__misure">
            <span className="dettagli-prodotto__misure__item">
              <span className="dettagli-prodotto__misure__icon">
                <Larghezza />
              </span>
              <span className="dettagli-prodotto__misure__label">
                {
                  selectedPosizione?.numero_colori?.[0]?.personalizzazioni_objects?.[0]
                    ?.dimensione_larghezza
                }{' '}
                cm
              </span>
            </span>
            <span className="dettagli-prodotto__misure__item">
              <span className="dettagli-prodotto__misure__icon">
                <Altezza />
              </span>
              <span className="dettagli-prodotto__misure__label">
                {
                  selectedPosizione?.numero_colori?.[0]?.personalizzazioni_objects?.[0]
                    ?.dimensione_altezza
                }{' '}
                cm
              </span>
            </span>
          </div>
        }
      />

      <DettagliProdottoData
        label={t('Max. numero colori di stampa')}
        value={
          <div className="dettagli-prodotto__colori">
            <p className="dettagli-prodotto__colori__row">
              <span
                className={`dettagli-prodotto__colori__icon ${
                  !selectedPosizione.numero_colori?.[0]?.full_color
                    ? 'dettagli-prodotto__colori__icon__goccia'
                    : ''
                }`}
              >
                {!selectedPosizione.numero_colori?.[0]?.full_color &&
                  selectedPosizione.numero_colori.length > 0 ? (
                  [...Array(selectedPosizione.numero_colori.length)].map((k, i) => (
                    <Goccia key={`dettagli-prodotto-goccia-${i}`} />
                  ))
                ) : (
                  <span>
                    {selectedPosizione.numero_colori?.[0]?.codice === '000' ? (
                      <GocciaColor id={`dettagli-prodotto-gocciacolor-${item.id}-${selectedPosizione.id}`} />
                    ) : (
                      <GocciaSlash />
                    )}
                  </span>
                )}
              </span>
              <span className="dettagli-prodotto__colori__label">
                {selectedPosizione?.numero_colori?.length > 0 &&
                  selectedPosizione.numero_colori[0].full_color
                  ? selectedPosizione.numero_colori[0].nome
                  : selectedPosizione?.numero_colori?.length}
              </span>
            </p>
          </div>
        }
      />

      {showPrezziLink && (
        <DettagliProdottoData
          label={t('Listino stampa')}
          value={
            <div className="dettagli-prodotto__colori__show-prezzi">
              <a onClick={() => handleVisualizzaPrezziListini?.()}>
                <Trans chiave="Visualizza prezzi" />
              </a>
            </div>
          }
        />
      )}

      {confezionamento && (
        <DettagliProdottoData
          label={t('Tipo confezionamento')}
          value={
            <>
              {confezionamento}
              {showPrezziConfezionamentoLink && (
                <span className="dettagli-prodotto__colori__show-prezzi dettagli-prodotto__colori__show-prezzi--confezionamento">
                  <a onClick={() => handleVisualizzaPrezziConfezionamento?.()}>
                    <Trans chiave="Visualizza prezzi" />
                  </a>
                </span>
              )}
            </>
          }
        />
      )}

      {!service_gift && (
        <DettagliProdottoData
          label={t('Info sulla stampa')}
          value={
            <span>
              <Link legacyBehavior href={'/strumenti-servizi/tecniche-stampa'}>
                <a>
                  <Trans chiave="Guida alle tecniche di stampa" />
                </a>
              </Link>
            </span>
          }
        />
      )}
    </div>
  ) : (
    <></>
  )
}

const DettagliProdottoTabPersonalizzazione = ({
  personalizzazioni,
  prezziPersonalizzazioni,
  t,
  prodotto,
  refTableSchedaProdotto,
  handleVisualizzaPrezziListini,
  handleVisualizzaPrezziConfezionamento,
  selectedTecnica,
  setSelectedTecnica,
  selectedPosizione,
  setSelectedPosizione,
}) => {
  const tabs = useMemo(() => {
    return (
      personalizzazioni?.tecniche?.map((item) => ({
        label: item?.nome,
        id: item.id,
        tecnica: item,
        component: (
          <DettagliProdottoTab
            item={item}
            t={t}
            prodotto={prodotto}
            refTableSchedaProdotto={refTableSchedaProdotto}
            showPrezziLink={
              prezziPersonalizzazioni?.tecniche?.[0]?.posizioni?.[0]?.numero_colori?.[0]
                ?.personalizzazioni_objects?.[0]?.prezzi_personalizzazione?.length > 0
            }
            handleVisualizzaPrezziListini={handleVisualizzaPrezziListini}
            showPrezziConfezionamentoLink={
              prezziPersonalizzazioni?.tecniche?.[0]?.posizioni?.[0]?.numero_colori?.[0]
                ?.personalizzazioni_objects?.[0]?.prezzi_confezionamento?.length > 0
            }
            handleVisualizzaPrezziConfezionamento={handleVisualizzaPrezziConfezionamento}
            selectedPosizione={selectedPosizione}
            setSelectedPosizione={setSelectedPosizione}
          />
        ),
      })) || []
    )
  }, [personalizzazioni, selectedTecnica, selectedPosizione])

  const [internalSelectedTab, setInternalSelectedTab] = useState(
    selectedTecnica ? selectedTecnica.id : tabs[0]?.id
  )

  useEffect(() => {
    const tecnica = tabs.find((tab) => tab.id === internalSelectedTab)?.tecnica
    if (tecnica && tecnica !== selectedTecnica) {
      setSelectedTecnica(tecnica)
    }
  }, [internalSelectedTab, tabs])

  if (!personalizzazioni || !personalizzazioni.tecniche?.length || !tabs?.length) {
    return <></>
  }
  return (
    <Tabs
      tabs={tabs}
      activeId={internalSelectedTab}
      onTabSelect={(tabId) => setInternalSelectedTab(tabId)}
      className="dettagli-prodotto__personalizzazione-tabs"
    />
  )
}

export default React.memo(DettagliProdotto)
